export type OnboardingDestination = "home" | "onboard" | "unknown";

/**
 * Decide where an authenticated session should go after a profile read.
 *
 * Onboarding completion is monotonic. A missing/failed profile read is not
 * evidence the user is new — that race is what bounced completed users
 * between /login and /onboard.
 */
export function resolveOnboardingDestination(input: {
    profile?: {onboardPricing?: boolean} | null;
    onboardingCompleteCached?: boolean;
}): OnboardingDestination {
    if (input.profile?.onboardPricing === true || input.onboardingCompleteCached) {
        return "home";
    }
    if (input.profile) {
        return "onboard";
    }
    return "unknown";
}

/**
 * Onboarding pages must not hard-nav to /login while Firebase already has a
 * restored session and AuthContext has not caught up (or the 4s watchdog
 * failed open as signed-out).
 */
export function shouldKickOnboardingToLogin(input: {
    loading: boolean;
    contextUser: {uid?: string} | null | undefined;
    firebaseCurrentUser: {uid?: string} | null;
}): boolean {
    if (input.loading || input.contextUser === undefined) {
        return false;
    }
    if (input.contextUser) {
        return false;
    }
    if (input.firebaseCurrentUser) {
        return false;
    }
    return true;
}
